/**
 * @fileoverview Application Constants
 * @description Central location for all application-wide constants
 * @module constants/app
 */

// HTTP Status Codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};

// Local Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER_PREFERENCES: 'user_preferences',
  THEME: 'theme',
  LANGUAGE: 'language',
};

// Route Paths
export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  LOGIN: '/login',
  LOGOUT: '/logout',
  NOT_FOUND: '/404',
  UNAUTHORIZED: '/unauthorized',
};

// User Roles
export const USER_ROLES = {
  ADMIN: 'admin',
  LEAD: 'lead',
  VIEWER: 'viewer',
  SCRUM_MASTER: 'scrum_master',
  SPRINT_PLANNER: 'sprint_planner',
};

// Application Modules
export const MODULES = {
  GITHUB_METRICS: 'github_metrics',
  TEST_CALENDAR: 'test_calendar',
  PNR_GENERATOR: 'pnr_generator',
  MODEL_CONTEXT_PROTOCOL: 'model_context_protocol',
  INCIDENT_ANALYSIS: 'incident_analysis',
  GITHUB_USER_METRICS: 'github_user_metrics',
  TEST_AUTOMATION_LEVERAGE: 'test_automation_leverage',
  LINES_OF_CODE: 'lines_of_code',
  PIPELINE_SERVICE: 'pipeline_service',
  REPORT_LOGS: 'report_logs',
  REPORTS: 'reports',
  ADMIN_RBAC: 'admin_rbac',
  REGRESSION_OPTIMIZER: 'regression_optimizer',
  ZAMLA_REPORT: 'zamla_report',
  COPILOT_COST: 'copilot_cost',
  BUSINESS_PORTFOLIO: 'business_portfolio',
  DEADHEAD_PNR: 'deadhead_pnr',
  AI_TEST_DATA_GENERATION: 'ai_test_data_generation',
  APP_INSIGHTS: 'app_insights',
  FLIGHT_CREW_DEADLETTER: 'flight_crew_deadletter',
  SERVICEBUS_EXPLORER: 'servicebus_explorer',
  FLIGHT_CREW_COMPARE: 'flight_crew_compare',
  CREW_PIPELINE_CHECK: 'crew_pipeline_check',
  AZURE_FUNCTION_HEALTH: 'azure_function_health',
  AI_EVALUATION_RESULTS: 'ai_evaluation_results',
};

// Module display names
export const MODULE_DISPLAY_NAMES = {
  [MODULES.GITHUB_METRICS]: 'GitHub Metrics',
  [MODULES.TEST_CALENDAR]: 'Test Calendar',
  [MODULES.PNR_GENERATOR]: 'PNR Generator',
  [MODULES.MODEL_CONTEXT_PROTOCOL]: 'AI Native Test Automation',
  [MODULES.INCIDENT_ANALYSIS]: 'Incident Intelligence',
  [MODULES.GITHUB_USER_METRICS]: 'GitHub User Metrics',
  [MODULES.TEST_AUTOMATION_LEVERAGE]: 'AI Leveraged Test Generation',
  [MODULES.LINES_OF_CODE]: 'Lines of Code Report',
  [MODULES.PIPELINE_SERVICE]: 'Pipeline Service',
  [MODULES.REPORT_LOGS]: 'Report Logs',
  [MODULES.REPORTS]: 'Reports',
  [MODULES.ADMIN_RBAC]: 'Admin Panel',
  [MODULES.REGRESSION_OPTIMIZER]: 'Regression Pack Optimizer',
  [MODULES.ZAMLA_REPORT]: 'ZAMLA Report',
  [MODULES.COPILOT_COST]: 'Copilot Finops',
  [MODULES.BUSINESS_PORTFOLIO]: 'Business Portfolio',
  [MODULES.DEADHEAD_PNR]: 'DH PNR Generator',
  [MODULES.AI_TEST_DATA_GENERATION]: 'Agentic Test Data Orchestrator',
  [MODULES.APP_INSIGHTS]: 'App Insights',
  [MODULES.FLIGHT_CREW_DEADLETTER]: 'Flight Crew DLQ Search',
  [MODULES.SERVICEBUS_EXPLORER]: 'Service Bus Explorer',
  [MODULES.FLIGHT_CREW_COMPARE]: 'Flight vs Crew Compare',
  [MODULES.CREW_PIPELINE_CHECK]: 'Crew Pipeline Check',
  [MODULES.AZURE_FUNCTION_HEALTH]: 'Azure Function Health',
  [MODULES.AI_EVALUATION_RESULTS]: 'AI Evaluation Results',
};

// Operations (permissions)
export const OPERATIONS = {
  READ: 'read',
  WRITE: 'write',
  DELETE: 'delete',
  MANAGE: 'manage',
};

// Access Request Statuses
export const REQUEST_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

// Theme Constants
export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
  SYSTEM: 'system',
};

// Status Types
export const STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};
